<template>
  <div id="app">
    <div>
      <confirm ref="confirm"></confirm>
      <loader v-model="statusval.loading"></loader>
      <arksnackbar v-model="statusval"></arksnackbar>
      <yetkidialog ref="yetkidialog"></yetkidialog>
    </div>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>
                <v-layout align-center>
                  {{  this.$t ('Current-Movement-Transfer') }}
                </v-layout>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom left v-if="menuitems != undefined">
                <template v-slot:activator="{ on }">
                  <v-btn dark icon v-on="on">
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-tile
                    v-for="(item, i) in menuitems"
                    :key="i"
                    @click="menuClick(i)"
                  >
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container
            fluid
            v-if="tarihfield == undefined || tarihfield == false"
          >
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 sm6 md2>
                  <v-layout align-center justify-start row fill-height>
                    <v-form
                      ref="formaktarim"
                      id="formaktarim"
                      method="post"
                      enctype="multipart/form-data"
                      v-model="valid"
                      lazy-validation
                    >
                      <input
                        hidden
                        type="file"
                        id="files"
                        ref="files"
                        multiple
                        accept=".csv, .xls, .xlsx "
                        v-on:change="handleFilesUpload()"
                      />
                    </v-form>
                    <v-btn
                      :loading="false"
                      :disabled="false"
                      color="info"
                      dark
                      @click="addFiles()"
                    >
                      <v-icon color="white" left>attach_file</v-icon>
                      {{ $t("Select-Transfer-File") }}
                    </v-btn>

                    <div v-show="load2">
                      <v-btn
                        small=""
                        fab
                        @mouseenter="tooltip = true"
                        @mouseleave="tooltip = false"
                        ref="fab"
                        @click="btnSubmitFiles()"
                        color="info"
                        dark
                      >
                        <v-icon>redo</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>{{ $t("Transfer-Selected") }}</span>
                      </v-tooltip>
                    </div>

                    <!-- <div v-if="status.loading">
                      <v-layout>
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-layout>
                    </div> -->
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md4> </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-alert
                    :value="true"
                    :color="alertcolor"
                    icon="check_circle"
                    outline
                  >
                    {{ alertmessage }}
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>
          <v-container fluid v-if="tarihfield == true">
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 sm6 md2>
                  <v-form ref="formtarih" v-model="valid" lazy-validation>
                    <tarihcomp
                      :etiket="$t('Select-Date')"
                      :detaygizle="false"
                      v-model="date"
                      v-bind:defaultvalue="'ok'"
                      :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    ></tarihcomp>
                  </v-form>
                </v-flex>

                <v-flex>
                  <v-layout align-start="" justify-center column fill-height>
                    <div v-if="load1">
                      <v-btn
                        small=""
                        @mouseenter="tooltip = true"
                        @mouseleave="tooltip = false"
                        ref="fab"
                        @click="btnAktar()"
                        color="info"
                        fab
                        dark
                      >
                        <v-icon>reply_all</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>{{$t('Transfer-Reservations')}}</span>
                      </v-tooltip>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>
          <!-- <div class="large-12 medium-12 small-12 cell">
          <template v-for="(file, key) in files">
            <v-chip :key="file.key" close @input="removeFile(key)">
              <strong>{{ file.name }}</strong>&nbsp;
            </v-chip>
          </template>
        </div> -->

          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-toolbar size="120px" dark color="info">
                <v-toolbar-title>{{$t('Transferred-Current-Transactions')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  flat=""
                  solo-inverted=""
                  hide-details
                  v-model="search3"
                  :label="$t('Search')"
                  append-icon="search"
                  
                >
                </v-text-field>
              </v-toolbar>

              <v-card>
                <v-data-table
                  :headers="headers"
                  :rows-per-page-items="[20, 500]"
                  :items="itemsok"
                  :search="search3"
                >
                  <template slot="items" slot-scope="props">
                    <tr item>
                      <td class="text-xs-left">{{ props.item.SatirNo }}</td>
                      <td class="text-xs-left">{{ props.item.SaveInput.Aciklama }}</td>
                      <td class="text-xs-left">{{ props.item.aciklama }}</td>
                    </tr>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="error"
                    icon="warning"
                  >
                    {{ $t("No-records-searched-for", { value: search3 }) }}
                  </v-alert>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-toolbar size="120px" dark color="red">
                <v-toolbar-title>{{$t('Failed-Current-Movements')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  flat=""
                  solo-inverted=""
                  hide-details
                  v-model="search4"
                  :label="$t('Search')"
                  append-icon="search"
                >
                </v-text-field>
              </v-toolbar>
              <v-card>
                <v-data-table
                  :headers="headers"
                  :rows-per-page-items="[20, 500]"
                  :items="itemsno"
                  :search="search4"
                >
                  <template slot="items" slot-scope="props">
                    <tr item>
                      <td class="text-xs-left">{{ props.item.SatirNo }}</td>
                      <td class="text-xs-left">{{ props.item.SaveInput.Aciklama }}</td>
                      <td class="text-xs-left">{{ props.item.aciklama }}</td>
                    </tr>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="error"
                    icon="warning"
                  >
                    {{ $t("No-records-searched-for", { value: search4 }) }}
                  </v-alert>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card>
    </v-app>


  </div>
</template>

<script>
import confirm from "@/components/app/coper/comp/confirm.vue";
import loader from "@/components/app/coper/comp/loader.vue";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
import customdialog from "@/components/app/coper/comp/customdialog.vue";
import helpers from "@/components/app/customcomp/helpers.js";

import tool from "@/components/app/coper/tools";
import auth from "@/api/auth";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tarihcomp from "@/components/app/customcomp/tarihim";

export default {
  props: ["value", "title", "status", "tarihfield", "menuitems"],
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },

      headers: [
        {
          text: this.$t('Line-Number'),
          value: "Satır No",
        },
        {
          text: this.$t('EXPLANATION'),
          value: "Açıklama",
        },
        {
          text: this.$t('Status'),
          value: "Durum",
        },
      ],
      itemsno: [],
      itemsok: [],
      alertcolor: "red",
      alertmessage: this.$t("file-has-been-chosen"),
      search3: "",
      search4: "",
    

      files: [],
      valid: true,
      load2: false,
      load3: false,
      butondurum: true,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      tooltip: false,
      el: null,
      date: null,
    };
  },
  components: {
    confirm,
    loader,
    arksnackbar,
    customdialog,
    yetkidialog,
    tarihcomp,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  computed: {
    model: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
    statusval: {
      get: function () {
        if (this.status == null) {
          return tool.NewSatatus();
        } else {
          return this.status;
        }
      },
    },
  },

  watch: {
    model(val) {
      this.watchmodel(val);
    },
  },
  mounted() {
    this.el = this.$refs.fab.$el;

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },

  methods: {

    menuClick(index) {
      this.$emit("menuclick", index);
    },

    watchmodel(val) {
      this.itemsok = [];
      this.itemsno = [];

      if (val) {
        val.forEach((element) => {
          if (element.basarili) {
            this.itemsok.push(element);
            //aktarilan = aktarilan + 1
          } else {
            this.itemsno.push(element);
          }
        });
      }
    },
    handleFilesUpload() {
      this.files = [];

      let uploadedFiles = this.$refs.files.files;

      if (uploadedFiles.length > 0) {
        this.alertcolor = "success";
        this.alertmessage =
          
          uploadedFiles.length +
          " " +
          this.$t("pcs-of-files-selected");
        this.load2 = true;

        for (var i = 0; i < uploadedFiles.length; i++) {
          this.files.push(uploadedFiles[i]);
        }
      } else {
        this.alertmessage = this.$t("file-has-been-chosen");
        this.alertcolor = "red";
        this.load2 = false;
      }
    },
    btnSubmitFiles() {
      this.$refs.confirm
        .open(
          this.$t('Current-Movement-Transfer'),
           this.$t('Transfer-Files?'),
          {
            color: "red",
          }
        )
        .then((confirm) => {
          if (confirm == true) {
            this.$emit("submitfile", this.files);
          }
        });
    },

    btnAktar() {
      this.$refs.confirm
        .open(this.$t('Current-Movement-Transfer'),  this.$t('Transfer-Files?'), {
          color: "red",
        })
        .then((confirm) => {
          if (confirm == true) {
            this.$emit("aktar", this.date);
          }
        });
    },

    removeFile(key) {
      this.files.splice(key, 1);
    },
    removeAllFiles() {
      this.$refs.confirm
        .open(this.$t('Delete-File'), this.$t("Delete-the-Files"), {
          color: "red",
        })
        .then((confirm) => {
          if (confirm == true) {
            this.files = [];
          }
        });
    },

    addFiles() {
      this.$refs.files.click();
    },

    load1() {
      return this.files.length <= 0;
    },
    git: git,
    
  },
};

function git(v) {
  let url = "#/coper/rezervasyon/index/id?" + "islem=get&PNR_No=" + v.pnrNo;
  window.open(url, "_blank");
}




</script>